import React from "react";
import { Heading, T } from "../components/helpful";
import crowdriff from "../assets/img/image-photo-gallery.jpg"

/* The `Picture` class is a React component that displays a page title, description, and a link to the
Crowdriff platform for viewing and downloading pictures and videos. 
@author lionel ghogue ngondeke <lionelladrog@gmail.com>
*/
export default class Picture extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      pageTitle: <T value={"Pictures & Videos"} />,
      hotelImg: 0,
      desc: '',
    };
  }
  subHeading = () => {
    return <>{this.state.desc}</>;
  };
  
  
  render() {

    let url = this.props.parentID==="pictures_videos"?"https://platform.crowdriff.com/m/beachcomber-resorts--hotels-/album/69601":"https://platform.crowdriff.com/m/beachcomber-resorts--hotels-"
    
    
    return (
      <div>
        <div className="">
          <div>
            <Heading heading={this.state.pageTitle} Desc={this.subHeading} />
          </div>

          <div className="main-content">
            <p>
              You will be redirected to the Crowdriff platform, where you can
              view and download pictures and videos.{" "}
              <a
              target="_blank"
              rel="noreferrer"
                href={url}
                className="mt-4"
              >
                <img src={crowdriff} alt="Crowdriff platform redirection" className="mt-4 img-fuild "/>
               
              </a>{" "}
            
            </p>
          </div>
        </div>
      </div>
    );
  }
}
